import { useMutation, useQueryClient } from '@tanstack/react-query'
import { authKeys } from '@/features/auth/api'
import { invalidateDisplays } from '@/features/displays/api'
import { api, unwrap } from '@/lib/api'
import type { DataEnvelope, PairingClaimRequest, PairingClaimResult, PairingLookup } from '@/types/api'

export function usePairingLookup() {
  return useMutation({
    mutationFn: (input: { code: string; nonce: string | null }) => unwrap(api.post<DataEnvelope<PairingLookup>>('/pairing/lookup', input)),
  })
}

export function usePairingClaim() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (body: PairingClaimRequest) => unwrap(api.post<DataEnvelope<PairingClaimResult>>('/pairing/claim', body)),
    onSuccess: (result) => {
      invalidateDisplays(qc, result.display.id)
      void qc.invalidateQueries({ queryKey: authKeys.me() })
      void qc.invalidateQueries({ queryKey: ['onboarding'] })
    },
  })
}
